<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-3 page-title">
            <h3 class="text-center mt-2 mal-text custom-title">റിലീഫ് രെജിസ്ട്രേഷൻ</h3>
        </div>
    </div>
    <div class="section pt-0 mt-1 pb-2">
        <div class="card">
            <div class="card-body">
                <Form @submit="storeData" :validation-schema="schema">
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="receipt_number">
                                കുടുംബ നാഥന്റെ പേര്
                                <span class="text-danger">*</span>
                            </label>
                            <Field name="family_leader_name" type="text" class="form-control" :disabled="isEditLocked"
                                v-model="formData.family_leader_name" placeholder="പേര്" autocomplete="off" />
                            <ErrorMessage name="family_leader_name" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label text-primary mal-text" for="text4b">
                                കുടുംബ നാഥൻ പുരുഷനാണോ അതോ സ്ത്രീയാണോ
                                <span class="text-danger">*</span>
                            </label>
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" value="Male" name="family_leader_sex" :disabled="isEditLocked"
                                    id="family_leader_sex_1" v-model="formData.family_leader_sex" />
                                <label class="form-check-label" for="family_leader_sex_1">പുരുഷൻ &nbsp;</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" value="Female" name="family_leader_sex" :disabled="isEditLocked"
                                    id="family_leader_sex_2" v-model="formData.family_leader_sex" />
                                <label class="form-check-label" for="family_leader_sex_2">സ്ത്രീ</label>
                            </div>
                            <br />
                            <ErrorMessage name="family_leader_sex" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="receipt_number">
                                കുടുംബ നാഥന്റെ വയസ്സ്
                                <span class="text-danger">*</span>
                            </label>
                            <Field type="number" class="form-control" name="family_leader_age"
                                v-model="formData.family_leader_age" placeholder="00" autocomplete="off"
                                @wheel.prevent />
                            <ErrorMessage name="family_leader_age" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="receipt_number">
                                കുടുംബ നാഥന്റെ വീട്ട്‌ പേര്
                            </label>
                            <Field type="text" class="form-control" name="family_leader_family_name" :disabled="isEditLocked"
                                v-model="formData.family_leader_house_name" placeholder="വീട്ട്‌ പേര്"
                                autocomplete="off" />
                            <ErrorMessage name="family_leader_family_name" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="receipt_number">
                                കുടുംബത്തെ നേരിട്ട് ബന്ധപ്പെടാൻ കഴിയുന്ന ഫോൺ നമ്പർ<span class="text-danger">*</span>
                            </label>
                            <Field type="number" class="form-control" name="family_leader_mobile" :disabled="isEditLocked"
                                v-model="formData.family_leader_mobile" placeholder="ഫോൺ നമ്പർ" autocomplete="off"
                                @wheel.prevent
                                @input="mobileDuplicateError = ''; mobileInOldListMessage = ''" @blur="checkMobileDuplicate" />
                            <ErrorMessage name="family_leader_mobile" class="error-feedback" />
                            <div v-if="mobileDuplicateError && edit_source !== 'old'" class="error-feedback duplicate-msg">
                                <template v-if="mobileDuplicateDetails">
                                    <div>ഈ കുടുംബത്തെ നേരത്തെ രജിസ്റ്റർ ചെയ്തിട്ടുണ്ട്.</div>
                                    <div>രജിസ്ട്രേഷൻ: {{ mobileDuplicateDetails.district_name }}, {{ mobileDuplicateDetails.zone_name }}, {{ mobileDuplicateDetails.unit_name }}.</div>
                                    <div v-if="mobileDuplicateDetails.secretary_name || mobileDuplicateDetails.secretary_mobile">
                                        യൂണിറ്റ് സെക്രട്ടറി: {{ mobileDuplicateDetails.secretary_name || '—' }}, ഫോൺ:
                                        <a :href="'tel:' + (mobileDuplicateDetails.secretary_mobile || '')" class="tel-link">{{ mobileDuplicateDetails.secretary_mobile || '—' }}</a>
                                    </div>
                                </template>
                                <template v-else>{{ mobileDuplicateError }}</template>
                            </div>
                            <div v-if="mobileInOldListMessage && !editable_id" class="error-feedback old-list-msg">
                                <template v-if="mobileInOldListDetails">
                                    ഈ ഫോൺ നമ്പർ പഴയ ലിസ്റ്റിൽ ഉണ്ട്. ഈ അംഗം ഇതിനകം പഴയ ലിസ്റ്റിൽ ഉണ്ട് — പഴയ ലിസ്റ്റിൽ നിന്ന് എടുത്ത് രജിസ്റ്റർ ചെയ്യുക. രജിസ്ട്രേഷൻ: {{ mobileInOldListDetails.district_name }}, {{ mobileInOldListDetails.zone_name }}, {{ mobileInOldListDetails.unit_name }}.
                                    <span v-if="mobileInOldListDetails.secretary_name || mobileInOldListDetails.secretary_mobile">
                                        യൂണിറ്റ് സെക്രട്ടറി: {{ mobileInOldListDetails.secretary_name || '—' }}, ഫോൺ:
                                        <a :href="'tel:' + (mobileInOldListDetails.secretary_mobile || '')" class="tel-link">{{ mobileInOldListDetails.secretary_mobile || '—' }}</a>
                                    </span>
                                </template>
                                <template v-else>{{ mobileInOldListMessage }}</template>
                            </div>
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="receipt_number">
                                ഇപ്പൊൾ താമസിക്കുന്ന സ്ഥലം
                            </label>
                            <Field type="text" class="form-control" name="place" v-model="formData.place" :disabled="isEditLocked"
                                placeholder="താമസിക്കുന്ന സ്ഥലം" autocomplete="off" />
                            <ErrorMessage name="place" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic" v-if="showPanchayathClusterFields">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="panchayath">
                                പഞ്ചായത്ത് / മുനിസിപ്പാലിറ്റി
                                <span class="text-danger">*</span>
                            </label>
                            <Field as="select" class="form-control" name="panchayath_id" v-model="formData.panchayath_id"
                                :disabled="isEditLocked" @change="onPanchayathChange">
                                <option value="">പഞ്ചായത്ത് തിരഞ്ഞെടുക്കുക</option>
                                <option v-for="p in panchayath_list" :key="p.id" :value="p.id">{{ p.name }}</option>
                            </Field>
                            <ErrorMessage name="panchayath_id" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic" v-if="showClusterField">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="ward">
                                കുടുംബം താമസിക്കുന്ന ക്ലസ്റ്റർ ( കുടുംബത്തിൻറെ ഏറ്റവും അടുത്തുള്ള  ക്ലസ്റ്റർ തിരഞ്ഞെടുക്കുക )
                                <span class="text-danger">*</span>
                            </label>
                            <Field as="select" class="form-control" name="ward_id" v-model="formData.ward_id" :disabled="isEditLocked">
                                <option value="">Cluster തിരഞ്ഞെടുക്കുക</option>
                                <option v-for="w in ward_list" :key="w.id" :value="w.id">{{ w.name }}</option>
                            </Field>
                            <ErrorMessage name="ward_id" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="receipt_number">
                                കുടുംബത്തെ ലിസ്റ്റില് ഉൾപ്പെടുത്താൻ ഉള്ള ഏറ്റവും പ്രധാനപ്പെട്ട കാരണങ്ങൾ
                                <span class="text-danger">*</span>
                            </label>
                            <div class="form-check mb-1 col-12" v-for="(item, index) in relief_reason_list"
                                :value="item.id" v-bind:key="item.id" :set="(id = 'customCheckb' + (index + 1))">
                                <input :disabled="disable_all" name="relief_reason" type="checkbox"
                                    class="form-check-input" v-bind:id="id" v-bind:value="item.id"
                                    v-model="formData.relief_reason" />
                                <label class="form-check-label" v-bind:for="id">{{
                    item.name_mal
                }}</label>
                            </div>
                            <ErrorMessage name="relief_reason" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label text-primary mal-text" for="text4b">
                                ഈ കുടുംബം സകാതിന്റെ അവകാശികളിൽ ഉൾപ്പെടുന്നുണ്ടോ ?
                                <span class="text-danger">*</span>
                            </label>
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" value="Yes" name="zakath" id="zakath_1"
                                    v-model="formData.zakath" />
                                <label class="form-check-label" for="zakath_1">ഉണ്ട് &nbsp;</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" value="No" name="zakath" id="zakath_2"
                                    v-model="formData.zakath" />
                                <label class="form-check-label" for="zakath_2">ഇല്ല</label>
                            </div>
                            <ErrorMessage name="zakath" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="receipt_number">
                                കുടുംബത്തിൽ താമസിക്കുന്ന ആകെ ആളുകളുടെ എണ്ണം
                                <span class="text-danger">*</span>
                            </label>
                            <Field type="number" class="form-control" name="total_count" v-model="formData.total_count"
                                placeholder="എണ്ണം" autocomplete="off" @wheel.prevent />
                            <ErrorMessage name="total_count" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="receipt_number">
                                കുടുംബത്തിൽ ഉള്ള 16 വയസ്സിൽ താഴെ ഉള്ള കുട്ടികളുടെ എണ്ണം
                            </label>
                            <Field type="number" min="0" inputmode="numeric" @input="onLessThan16CountInput($event)"
                                class="form-control" name="lessthan_16_count"
                                v-model="formData.lessthan_16_count" placeholder="എണ്ണം" autocomplete="off"
                                @wheel.prevent />
                            <ErrorMessage name="lessthan_16_count" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="receipt_number">
                                പിതാവ് മരണപ്പെട്ടു കുട്ടികളുടെ എണ്ണം (16 വയസ്സിൽ താഴേ)
                            </label>
                            <Field type="number" class="form-control" name="yatheem_count"
                                v-model="formData.yatheem_count" placeholder="എണ്ണം" autocomplete="off"
                                @wheel.prevent />
                            <ErrorMessage name="yatheem_count" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="receipt_number">
                                ഭർത്താവ് മരണപ്പെട്ട വിധവകളുടെ എണ്ണം
                            </label>
                            <Field type="number" class="form-control" name="widow_count" v-model="formData.widow_count"
                                placeholder="എണ്ണം" autocomplete="off" @wheel.prevent />
                            <ErrorMessage name="widow_count" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="receipt_number">
                                കുടുംബത്തിന് ഈ വർഷം നൽകാൻ കഴിയുന്ന സഹായങ്ങൾ
                            </label>
                            <div class="form-check mb-1 col-12" v-for="(item, index) in relief_type_list"
                                :value="item.id" v-bind:key="item.id" :set="(id = 'ScustomCheckb' + (index + 1))">
                                <input name="relief_types[]" @change="getChild(item.item_value)"
                                    type="checkbox" class="form-check-input" v-bind:id="id" v-bind:value="item.id"
                                    v-model="formData.relief_types" />
                                <label class="form-check-label" v-bind:for="id">{{
                    item.name_mal
                }}</label>
                            </div>
                            <ErrorMessage name="relief_types" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic" v-if="hasChildRowsReady">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="receipt_number">
                                16 വയസ്സിൽ താഴെ ഉള്ള കുട്ടികളുടെ വിവരങ്ങൾ
                            </label>
                            <div v-for="index in childLength" :key="index" class="card text-white mb-2"
                                style="border: 1px solid blue; margin-top: 10px">
                                <div class="card-body" style="padding: 5px">
                                    <div class="row">

                                        <div class="col-12">
                                            <Field type="text" class="form-control" :name="'child_name[' + (index - 1) + ']'" :disabled="isChildEditLocked(index - 1)"
                                                v-model="formData.child[index - 1].name" placeholder="പേര്"
                                                autocomplete="off" />
                                        </div>
                                        <div class="col-6 pt-2">
                                            <div class="form-check form-check-inline">
                                                <input type="radio" class="form-check-input" value="Boy" :disabled="isChildEditLocked(index - 1)"
                                                    :name="'child_sex[' + (index - 1) + ']'" :id="'child_sex_1_' + (index - 1)"
                                                    v-model="formData.child[index - 1].sex" />
                                                <label class="form-check-label" :for="'child_sex_1_' + (index - 1)">Boy
                                                    &nbsp;</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <input type="radio" class="form-check-input" value="Girl" :disabled="isChildEditLocked(index - 1)"
                                                    :name="'child_sex[' + (index - 1) + ']'" :id="'child_sex_2_' + (index - 1)"
                                                    v-model="formData.child[index - 1].sex" />
                                                <label class="form-check-label"
                                                    :for="'child_sex_2_' + (index - 1)">Girl</label>
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <Field type="number" min="0" inputmode="numeric" class="form-control"
                                                :name="'child_age[' + (index - 1) + ']'"
                                                @input="onChildAgeInput(index - 1, $event)"
                                                v-model="formData.child[index - 1].age" placeholder="വയസ്സ് "
                                                autocomplete="off" @wheel.prevent />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group basic" v-if="editable_id && !isEditLocked">
                        <div class="input-wrapper">
                            <label class="label text-primary mal-text" for="text4b">
                                ഈ ഫാമിലിയെ ഈ വർഷത്തെ ലിസ്റ്റിൽ ഉൾപെടുത്തണോ?
                                <span class="text-danger">*</span>
                            </label>
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" value="Yes" name="this_year_reg"
                                    id="this_year_reg_1" v-model="formData.this_year_reg" />
                                <label class="form-check-label" for="this_year_reg_1">വേണം&nbsp;</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" value="No" name="this_year_reg"
                                    id="this_year_reg_2" v-model="formData.this_year_reg" />
                                <label class="form-check-label" for="this_year_reg_2">വേണ്ട</label>
                            </div>
                            <ErrorMessage name="this_year_reg" class="error-feedback" />
                        </div>
                    </div>

                    <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="loading">
                        <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                        <span>Save</span>
                    </button>
                </Form>
            </div>
        </div>
    </div>

    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>

    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>

<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import UserService from "../../services/user.service";
import $ from "jquery";

import AlertModel from "./../layouts/AlertModel.vue";
import DialogModel from "./../layouts/DialogModel.vue";
export default {
    name: "Admin List",
    props: {
        unit_id: null,
        permissions: Object,
    },
    components: {
        Form,
        Field,
        ErrorMessage,
        AlertModel,
        DialogModel,
    },
    data() {
        const nameRegex = /^[a-zA-Z0-9&._-\s]*$/g;
        const baseSchema = {
            family_leader_name: yup
                .string()
                .matches(nameRegex, "പേര് ഇംഗീഷിൽ ടൈപ്പ് ചെയ്യുക!")
                .required("ഫിൽ ചെയ്യുക!"),
            family_leader_mobile: yup.string().required("ഫിൽ ചെയ്യുക!"),
            family_leader_age: yup.string().required("ഫിൽ ചെയ്യുക!"),
            total_count: yup.string().required("ഫിൽ ചെയ്യുക!"),
        };
        return {
            loading: false,
            is_registered: false,
            edit_source: 'new',
            baseSchema,
            user_level: "",
            unit: [],
            alert_type: "",
            alert_message: "",
            dialog_message: "",
            dialog_action: "",
            dialog_action_params: [],
            relief_reason_list: [],
            relief_type_list: [],
            panchayath_list: [],
            ward_list: [],
            mobileDuplicateError: '',
            mobileDuplicateDetails: null,
            mobileInOldListMessage: '',
            mobileInOldListDetails: null,
            children_enable: false,
            formData: {
                family_leader_name: "",
                family_leader_sex: "",
                family_leader_age: "",
                family_leader_house_name: "",
                family_leader_mobile: "",
                place: "",
                panjayath: "",
                panchayath_id: "",
                ward_id: "",
                relief_reason: [],
                zakath: "",
                this_year_reg: "",
                total_count: 0,
                lessthan_16_count: 0,
                yatheem_count: 0,
                widow_count: 0,
                relief_types: [],
                child: [],
            },
            reliefFamily: [],
            old_child_count: 0,
            editable_id: ''
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        childLength() {
            return this.normalizeNonNegativeInt(this.formData.lessthan_16_count);
        },
        hasChildRowsReady() {
            return (
                this.childLength > 0 &&
                Array.isArray(this.formData.child) &&
                this.formData.child.length >= this.childLength
            );
        },
        isEditLocked() {
            // Lock fields when editing an entry that is already in this year's list (green tick).
            // Applies to both new list and old list edits - if member has green tick, fields are read-only.
            return !!this.editable_id && this.is_registered;
        },
        showPanchayathClusterFields() {
            return Array.isArray(this.panchayath_list) && this.panchayath_list.length > 1;
        },
        showClusterField() {
            if (!Array.isArray(this.panchayath_list)) return false;
            if (this.panchayath_list.length > 1) return true;
            // When only one panchayath: show cluster field if there is at least one cluster (single cluster shown as selected)
            if (this.panchayath_list.length === 1 && Array.isArray(this.ward_list) && this.ward_list.length >= 1) return true;
            return false;
        },
        schema() {
            const shape = { ...this.baseSchema };
            if (this.showPanchayathClusterFields) {
                shape.panchayath_id = yup.string().required("പഞ്ചായത്ത് തിരഞ്ഞെടുക്കുക!");
            }
            if (this.showClusterField) {
                shape.ward_id = yup.string().required("Cluster തിരഞ്ഞെടുക്കുക!");
            }
            return yup.object().shape(shape);
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
        } else {
            this.user_level = parseInt(this.$route.params.sub_level);
            if (this.unit_id == this.currentUser.unit_id || this.currentUser.user_level == 4) {
                this.editable = true;
            } else {
                this.editable = false;
            }
            this.$root.updateParent("Relief Registration");
            if (this.$route.params.family_id) {
                this.getReliefFamily(this.$route.params.family_id);
            }
            if (this.$route.query.registered !== undefined) {
                this.is_registered = this.$route.query.registered == 1;
            }
            if (this.$route.query.source) {
                this.edit_source = String(this.$route.query.source);
            }
        }
        this.getComboboxValues("RELIEF_REASON");
        this.getReliefTypesForEntry();
        this.loadPanchayaths();
        window.onpopstate = function () {
            if ($("body").hasClass("modal-open")) {
                location.reload();
            }
        };
    },
    methods: {
        isChildEditLocked(idx) {
            // Same locking rule as parent fields, but only if this child row is an existing saved record
            const hasEditableId = !!(this.formData.child && this.formData.child[idx] && this.formData.child[idx].editable_id);
            return hasEditableId && this.isEditLocked;
        },
        normalizeNonNegativeInt(value) {
            const n = parseInt(value ?? 0, 10);
            if (!Number.isFinite(n) || Number.isNaN(n)) return 0;
            return n < 0 ? 0 : n;
        },
        syncChildArrayLength() {
            const desired = this.normalizeNonNegativeInt(this.formData.lessthan_16_count);
            if (!Array.isArray(this.formData.child)) {
                this.formData.child = [];
            }

            // Trim extra rows if count reduced
            if (this.formData.child.length > desired) {
                this.formData.child.splice(desired);
            }

            // Add rows if count increased
            while (this.formData.child.length < desired) {
                this.formData.child.push({
                    name: "",
                    age: "",
                    sex: "",
                    editable_id: null,
                });
            }

            this.old_child_count = desired;
        },
        onLessThan16CountInput(e) {
            // Keep the count stable and non-negative while typing
            const next = this.normalizeNonNegativeInt(e?.target?.value);
            this.formData.lessthan_16_count = next;
            this.syncChildArrayLength();
        },
        onChildAgeInput(idx, e) {
            if (!this.formData.child || !this.formData.child[idx]) return;
            const next = this.normalizeNonNegativeInt(e?.target?.value);
            this.formData.child[idx].age = next;
        },
        buildDuplicateMessage(duplicateDetails) {
            if (!duplicateDetails) return 'ഈ കുടുംബത്തെ നേരത്തെ രജിസ്റ്റർ ചെയ്തിട്ടുണ്ട്.';
            const d = duplicateDetails;
            const place = [d.district_name, d.zone_name, d.unit_name].filter(Boolean).join(', ') || '—';
            let msg = 'ഈ കുടുംബത്തെ നേരത്തെ രജിസ്റ്റർ ചെയ്തിട്ടുണ്ട്. രജിസ്ട്രേഷൻ: ' + place + '.';
            if (d.secretary_name || d.secretary_mobile) {
                msg += ' യൂണിറ്റ് സെക്രട്ടറി: ' + (d.secretary_name || '—') + ', ഫോൺ: ' + (d.secretary_mobile || '—');
            }
            return msg;
        },
        checkMobileDuplicate() {
            const mobile = String(this.formData.family_leader_mobile || '').trim();
            if (mobile.length < 10) {
                this.mobileDuplicateError = '';
                this.mobileInOldListMessage = '';
                this.mobileInOldListDetails = null;
                return;
            }
            UserService.addAdmin('check-relief-mobile', {
                family_leader_mobile: mobile,
                editable_id: this.editable_id || null
            }).then(
                (response) => {
                    const data = response.data && response.data.data;
                    if (!response.data || response.data.status !== 'success' || !data) {
                        this.mobileDuplicateError = '';
                        this.mobileDuplicateDetails = null;
                        this.mobileInOldListMessage = '';
                        this.mobileInOldListDetails = null;
                        return;
                    }
                    if (data.duplicate) {
                        const details = data.duplicate_details;
                        this.mobileDuplicateDetails = details || null;
                        this.mobileDuplicateError = this.buildDuplicateMessage(details);
                        this.mobileInOldListMessage = '';
                        this.mobileInOldListDetails = null;
                    } else if (data.in_old_list) {
                        const details = data.in_old_list_details;
                        this.mobileInOldListMessage = details ? this.buildDuplicateMessage(details) : 'ഈ ഫോൺ നമ്പർ പഴയ ലിസ്റ്റിൽ ഉണ്ട്. ഈ അംഗം ഇതിനകം പഴയ ലിസ്റ്റിൽ ഉണ്ട് — പഴയ ലിസ്റ്റിൽ നിന്ന് എടുത്ത് രജിസ്റ്റർ ചെയ്യുക.';
                        this.mobileInOldListDetails = details || null;
                        this.mobileDuplicateError = '';
                        this.mobileDuplicateDetails = null;
                    } else {
                        this.mobileDuplicateError = '';
                        this.mobileDuplicateDetails = null;
                        this.mobileInOldListMessage = '';
                        this.mobileInOldListDetails = null;
                    }
                },
                () => {
                    this.mobileDuplicateError = '';
                    this.mobileDuplicateDetails = null;
                    this.mobileInOldListMessage = '';
                    this.mobileInOldListDetails = null;
                }
            );
        },
        loadPanchayaths() {
            const unitId = this.$route.params.id;
            if (!unitId) return;
            UserService.authGetRequest('location/panchayaths', { from: 'biodata', unit_id: unitId }).then(
                (response) => {
                    if (response.data && response.data.data && response.data.data.panchayaths) {
                        this.panchayath_list = response.data.data.panchayaths;
                        if (this.panchayath_list.length === 1) {
                            this.formData.panchayath_id = this.panchayath_list[0].id;
                            this.formData.panjayath = this.panchayath_list[0].name;
                            this.loadWards(this.panchayath_list[0].id);
                        }
                    } else {
                        this.panchayath_list = [];
                    }
                },
                () => { this.panchayath_list = []; }
            );
        },
        loadWards(panchayathId) {
            if (!panchayathId) {
                this.ward_list = [];
                return;
            }
            const unitId = this.$route.params.id;
            const params = { panchayath_id: panchayathId };
            if (unitId) {
                params.from = 'biodata';
                params.unit_id = unitId;
            }
            UserService.authGetRequest('location/wards', params).then(
                (response) => {
                    if (response.data && response.data.data && response.data.data.wards) {
                        this.ward_list = response.data.data.wards;
                        if (this.ward_list.length === 1) {
                            this.formData.ward_id = this.ward_list[0].id;
                        }
                    } else {
                        this.ward_list = [];
                    }
                },
                () => { this.ward_list = []; }
            );
        },
        onPanchayathChange() {
            this.formData.ward_id = '';
            this.loadWards(this.formData.panchayath_id);
        },
        getComboboxValues(code, id = null) {
            var data = {
                code: code,
                type_id: id,
            };
            UserService.getCombobox(data).then(
                (response) => {
                    switch (code) {
                        case "RELIEF_REASON":
                            this.relief_reason_list = response.data.data.list.options;
                            break;
                        default:
                            break;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.messafe =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        // Zone admin in another unit sees only ഈദ് കിസ്‌വ(ചെറിയ പെരുന്നാൾ) - type id 1113
        getReliefTypesForEntry(familyIdOverride = null, unitIdOverride = null) {
            const unit_id = unitIdOverride != null ? parseInt(unitIdOverride, 10) : parseInt(this.$route.params.id, 10);
            const family_id = familyIdOverride != null ? familyIdOverride : (this.$route.params.family_id ? parseInt(this.$route.params.family_id, 10) : null);
            const data = { unit_id };
            if (family_id) data.family_id = family_id;
            const EID_KISWA_SMALL_TYPE_ID = 1113;
            UserService.authPostRequest('get-relief-types-for-entry', data).then(
                (response) => {
                    if (response.data.status === 'success' && response.data.data.list && response.data.data.list.options) {
                        let list = response.data.data.list.options;
                        const isZoneAdmin = this.currentUser && parseInt(this.currentUser.user_level) === 3;
                        const isOtherUnit = this.currentUser && this.currentUser.unit_id != null && String(unit_id) !== String(this.currentUser.unit_id);
                        if (isZoneAdmin && isOtherUnit) {
                            list = list.filter(t => parseInt(t.id) === EID_KISWA_SMALL_TYPE_ID);
                        }
                        this.relief_type_list = list;
                        // Keep formData.relief_types in sync with list (backend may have filtered by "disabled for zones" in both new and edit)
                        const allowedIds = list.map(t => parseInt(t.id));
                        if (Array.isArray(this.formData.relief_types) && this.formData.relief_types.length) {
                            this.formData.relief_types = this.formData.relief_types.filter(id => allowedIds.includes(parseInt(id)));
                        }
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        checkStudent() {
            let stud_items = false;
            this.formData.relief_types.forEach(element => {
                this.relief_type_list.forEach(element_ => {
                    if (element_.id == element) {
                        if (element_.item_value == 'student') {
                            stud_items = true;
                        }
                    }
                });
            });

            return stud_items;
        },
        getChild(type = null, count_inc = null) {
            if (type == "student") {
                if (!this.formData.lessthan_16_count) {
                    // Remove student item safely (don't rely on pop which can remove a different selection)
                    const studentType = this.relief_type_list.find(t => t.item_value === 'student');
                    if (studentType) {
                        this.formData.relief_types = (this.formData.relief_types || []).filter(id => id !== studentType.id);
                    }
                    this.alert_type = "Warning";
                    this.alert_message = "16 വയസ്സിനു താഴെ ഉള്ള കുട്ടികളുടെ എണ്ണം നൽകുക.";
                    this.$refs.alert_model.openModel();
                } else {
                    this.syncChildArrayLength();
                }
            } else if (count_inc) {
                // Keep child rows in sync with the count input (handles increase + decrease)
                this.syncChildArrayLength();
            }
            if (this.checkStudent()) {
                this.children_enable = true;
            } else {
                this.children_enable = false;
            }

            console.log(this.formData.child);

        },
        storeData() {
            let data = { ...this.formData };
            const selectedPanchayath = this.panchayath_list.find(p => String(p.id) === String(this.formData.panchayath_id));
            if (selectedPanchayath) {
                data.panjayath = selectedPanchayath.name;
            }
            data.unit_id = parseInt(this.$route.params.id);
            data.user_level = parseInt(this.$route.params.sub_level);
            data.editable_id = this.editable_id;
            data.edit_source = this.edit_source;
            let child_validation = false;
            // Always ensure child array matches count before validation
            this.syncChildArrayLength();
            if (data.lessthan_16_count > 0) {
                (data.child || []).slice(0, this.normalizeNonNegativeInt(data.lessthan_16_count)).forEach(element => {
                    if (element.name == '' || element.age == '' || element.sex == '') {
                        child_validation = true;
                    }
                });
                if (child_validation) {
                    this.alert_type = 'Warning';
                    this.alert_message = '16 വയസ്സിൽ താഴെ ഉള്ള കുട്ടികളുടെ വിവരങ്ങൾ പൂർണ്ണമായി നൽകുക.';
                    this.$refs.alert_model.openModel();
                    this.loading = false;
                    return false;
                }
            }

            this.mobileDuplicateError = '';
            this.mobileDuplicateDetails = null;
            if (!this.editable_id && this.mobileInOldListMessage) {
                this.alert_type = 'Warning';
                this.alert_message = 'ഈ അംഗം ഇതിനകം പഴയ ലിസ്റ്റിൽ ഉണ്ട്. പഴയ ലിസ്റ്റിൽ നിന്ന് എടുത്ത് രജിസ്റ്റർ ചെയ്യുക.';
                this.$refs.alert_model.openModel();
                this.loading = false;
                return;
            }
            this.mobileInOldListMessage = '';
            this.mobileInOldListDetails = null;
            UserService.addAdmin('store-relief-family', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        setTimeout(() => {
                            this.$router.go(-1);
                        }, 2000);

                        this.loading = false;
                        this.message = '';
                    } else if (response.data.status == 'warning') {
                        if (response.data.error_type === 'duplicate_mobile') {
                            const details = response.data.data && response.data.data.duplicate_details;
                            if (this.edit_source !== 'old') {
                                this.mobileDuplicateDetails = details || null;
                                this.mobileDuplicateError = this.buildDuplicateMessage(details);
                            }
                            this.alert_type = 'Warning';
                            this.alert_message = response.data.message || this.buildDuplicateMessage(details);
                            this.$nextTick(() => {
                                if (this.$refs.alert_model) this.$refs.alert_model.openModel();
                            });
                        } else if (response.data.error_type === 'in_old_list') {
                            const details = response.data.data && response.data.data.in_old_list_details;
                            this.mobileInOldListDetails = details || null;
                            this.mobileInOldListMessage = details ? this.buildDuplicateMessage(details) : response.data.message;
                            this.alert_type = 'Warning';
                            this.alert_message = response.data.message || 'ഈ അംഗം ഇതിനകം പഴയ ലിസ്റ്റിൽ ഉണ്ട്. പഴയ ലിസ്റ്റിൽ നിന്ന് എടുത്ത് രജിസ്റ്റർ ചെയ്യുക.';
                            this.$nextTick(() => {
                                if (this.$refs.alert_model) this.$refs.alert_model.openModel();
                            });
                        } else {
                            this.alert_type = 'Warning';
                            this.alert_message = response.data.message;
                            this.$nextTick(() => {
                                if (this.$refs.alert_model) this.$refs.alert_model.openModel();
                            });
                        }
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.messafe = (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getReliefFamily(id) {
            let data = {
                id: id
            }
            UserService.authPostRequest('get-relief-family', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.reliefFamily = response.data.data.list;
                        if (this.$route.query.registered === undefined) {
                            this.is_registered = this.reliefFamily.this_year_registered;
                        }
                        this.formData.family_leader_name = this.reliefFamily.family_head_name;
                        this.formData.family_leader_sex = this.reliefFamily.family_head_gender;
                        this.formData.family_leader_age = this.reliefFamily.family_head_age;
                        this.formData.family_leader_house_name = this.reliefFamily.family_head_surname;
                        this.formData.family_leader_mobile = this.reliefFamily.family_contact;
                        this.formData.place = this.reliefFamily.family_place;
                        this.formData.panjayath = this.reliefFamily.family_panchayath;
                        this.formData.panchayath_id = this.reliefFamily.panchayath_id ? String(this.reliefFamily.panchayath_id) : '';
                        this.formData.ward_id = this.reliefFamily.ward_id ? String(this.reliefFamily.ward_id) : '';
                        if (this.formData.panchayath_id) {
                            this.loadWards(this.formData.panchayath_id);
                        }
                        this.formData.zakath = this.reliefFamily.zakath_eligible;
                        this.formData.total_count = this.reliefFamily.family_members_count;
                        this.formData.lessthan_16_count = this.reliefFamily.boys_count;
                        this.formData.yatheem_count = this.reliefFamily.orphan_count;
                        this.formData.widow_count = this.reliefFamily.widow_count;
                        this.editable_id = this.reliefFamily.id;
                        if (this.reliefFamily.family_reason_to_include) {
                            this.formData.relief_reason = JSON.parse(this.reliefFamily.family_reason_to_include);
                        }
                        if (this.reliefFamily.relief_types) {
                            this.formData.relief_types = JSON.parse(this.reliefFamily.relief_types);
                            if (response.data.data.child.length > 0) {
                                response.data.data.child.forEach(element => {
                                    this.formData.child.push({
                                        name: element.child_name,
                                        age: element.child_age,
                                        sex: element.child_sex,
                                        editable_id: element.id
                                    });
                                });
                                this.old_child_count = response.data.data.child.length;
                                this.children_enable = true;
                            }
                        }
                        this.getReliefTypesForEntry(this.reliefFamily.id, this.reliefFamily.unit_id);
                    }
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
    },
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.error-feedback .tel-link {
    color: inherit;
    text-decoration: underline;
    font-weight: 600;
}

.duplicate-msg div {
    margin-bottom: 2px;
}

.duplicate-msg div:last-child {
    margin-bottom: 0;
}

.old-list-msg {
    color: #856404;
    font-size: 0.9em;
}

.listview {
    margin-bottom: 0px;
}

.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.deleted-list-title {
    font-size: 15px;
}

.deleted-list {
    margin-bottom: 20px;
}

.deleted-info {
    background-color: #f2bbca;
    font-size: 12px;
}

.deleted-info strong {
    font-size: 18px;
    font-weight: 600;
}

.image-listview.text>li:after {
    left: 0px;
    /* height: 1px; */
    background-color: #1a418c;
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.green-tick {
    font-size: 18px;
    color: darkgreen;
}

.red-cross {
    font-size: 18px;
    color: red;
}

.qhls-text {
    font-style: italic;
    color: #266bd1;
}
</style>
